<template>
<div class="container-fluid">
  <div class="row">
    <div class="col-sm bg-light border py-2">
        <table id="myLabReqTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
            <thead class="text-white" style="background:Navy">
            <tr>
                <th>ยกเลิก</th>
                <th title="รับชำระเงิน">Paid</th>
                <th>สถานะ</th>
                <th>ชื่อสาขา</th>
                <th>เลขที่ใบตรวจ</th>
                <th>BC</th>
                <th>วันที่</th>
                <th>ชื่อ-สกุล คนไข้</th>
                <th>เพศ</th>
                <th>หน่วยงาน/บริษัท</th>
                <th>ชำระโดย</th>
                <th>สุทธิ</th>
                <th>ประเภทการตรวจ</th>
                <th>คำสั่ง</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="item in datalists" :key="item.ROID" v-bind:data-id="item.ROID" @click="tableChanged(item)">
                    <td class="text-danger"><b> {{ arrCancel[item.Cancel] }}</b></td>
                    <td class="">{{ arrPaid[item.Paid] }}</td>
                    <td class="">
                      <button id="btnGroupDrop1" type="button"
                          class="btn btn-outline btn-sm dropdown-toggle p-0" data-bs-toggle="dropdown" aria-expanded="false">
                          {{ arrDocStatus[item.Status] }}
                      </button>
                      <ul class="dropdown-menu pe-3" aria-labelledby="btnGroupDrop1">
                        <li class="mx-2 bg-danger text-white dropdown-item" @click="cancelRecord(item)" v-if="item.Cancel==0" title="การยกเลิกใบสั่งตรวจ จะทำให้ไม่สามารถเข้าถึงเอกสารได้"> Cancel </li>
                      </ul>
                    </td>
                    <td class="text-start">{{ item.BranchName }}</td>
                    <td class="text-start" :title=' "สิ่งส่งตรวจ : "+item.Specimen'>{{ item.RONo }}</td>
                    <td>
                      <!-- <button class="btn-sm py-0" title="พิมพ์สติกเกอร์บาร์โค้ด" @click="printROBarCode(item)"> <i class="fa fa-barcode"></i></button> -->
                      <!-- <button class="btn-sm py-0" title="พิมพ์สติกเกอร์บาร์โค้ด" @click="printROBarCode_Fs(item, 14)"> <i class="fa fa-barcode"></i></button> -->
                      <button id="btnGroupDropBarCode" type="button" title="พิมพ์สติกเกอร์บาร์โค้ด"
                          class="btn btn-outline-success btn-sm dropdown-toggle " data-bs-toggle="dropdown" aria-expanded="false">
                          <i class="fa fa-barcode"></i>
                      </button>
                      <ul class="dropdown-menu pe-3 bg-success" aria-labelledby="btnGroupDropBarCode">
                        <li class="mx-2 dropdown-item" @click="printROBarCode_Fs(item, 14)">พิมพ์ชื่อคนไข้ </li>
                        <li class="mx-2 dropdown-item" @click="printROBarCodeTestCode_Fs(item, 14)"> พิมพ์ชื่อคนไข้และเทสตรวจ </li>
                      </ul>
                    </td>
                    <td class="text-start">{{ item.DocDate }} {{item.DocTime}}</td>
                    <td class="text-start">{{ item.PatName }} {{ item.PatLName}}</td>
                    <td class="">{{ arrSex[item.Sex] }}</td>
                    <td class="text-start">{{ item.ReqClinicName }}</td>
                    <td v-if="item.PayType==0" class="text-start">{{ arrPayType[item.PayType] }}</td>
                    <td v-else class="text-start text-danger">{{ arrPayType[item.PayType] }}</td>
                    <td class="text-end">{{  numeralFormat(item.NetAmt, '0,0[.]00') }}</td>
                    <td class="text-start">{{ item.Test }} <span v-if="item.Test.length>0 && item.TestInPropack.length>0">/</span> {{ item.TestInPropack }}</td>
                    <td class="text-end" >
                        <button type="button" class="btn btn-primary btn-sm mx-1" v-if="item.Cancel==0"
                          id="Edit" @click="editRecord(item)">Edit</button>
                        <button id="btnGroupDrop1" type="button"
                            class="btn btn-outline-success btn-sm dropdown-toggle " data-bs-toggle="dropdown" aria-expanded="false">
                            พิมพ์
                        </button>
                        <ul class="dropdown-menu pe-3 bg-success" aria-labelledby="btnGroupDrop1">
                          <li class="mx-2 dropdown-item" @click="printROBlank(item, 'A5-1')" title="พิมพ์ใบสั่งตรวจ"> A5-1 พิมพ์ใบสั่งตรวจ </li>
                          <li class="mx-2 dropdown-item" @click="printROBlank(item, 'A4-1')" title="พิมพ์ใบสั่งตรวจ"> A4-1 พิมพ์ใบสั่งตรวจ </li>
                          <div class="dropdown-divider"></div>
                          <li class="mx-2 dropdown-item" @click="printROBlank(item, 'A5-2')" title="พิมพ์ใบสั่งตรวจ"> A5-2 พิมพ์ใบสั่งตรวจ+พารามิเตอร์ </li>
                          <li class="mx-2 dropdown-item" @click="printROBlank(item, 'A4-2')" title="พิมพ์ใบสั่งตรวจ"> A4-2 พิมพ์ใบสั่งตรวจ+พารามิเตอร์ </li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</div>

<img id="imageid" ref="imageid" hidden crossorigin="anonymous" v-bind:src="require('../assets/' +  globalCorpInfo.logoFile ) + '?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'">

<!-- formA5Idx= 'A5-1', 'A4-1'  -->
<!-- ตารางใบสั่งตรวจ แสดงเฉพาะชุดตรวจ -->
<div id="divToPrint" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}"> -->
  <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}">
    <thead>
      <tr class="text-start">
        <th>Test</th>
        <th>Specimen</th>
        <th>Category</th>
      </tr>
    </thead>
    <tbody>
      <tr class="text-start" v-for="item1 in A5reportDtl" :key="item1.TestID">
        <td style="width:500px;">{{item1.TestName}} <span v-if="item1.PropackName"> &nbsp; <i>[{{item1.PropackName}}]</i></span></td>
        <td style="width:100px;">{{item1.Specimen}}</td>
        <td style="width:100px;">{{item1.room_name}}</td>
      </tr>
      <tr>
        <td colspan="3"> <br> หมายเหตุ : {{A5reportHd.Remark}}</td>
      </tr>
    </tbody>
  </table>
</div>

<!-- formA5Idx= 'A5-2', 'A4-2'  -->
<!-- ตารางใบสั่งตรวจแบบ Master-Detail แต่ละชุดตรวจมีเทสตั้งแต่หนึ่งเทสขึ้นไป -->
<div id="divToPrint_MasterDtl" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}"> -->
  <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}">
    <thead>
      <tr class="text-start">
        <th>Test</th>
        <th>Result</th>
        <th>Unit</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="item1 in A5GroupTest" :key="item1.TestID">
        <tr class="text-start" v-if="item1.CountItemTest>1">
          <!-- Check : New Page or not -->
          <!-- <td colspan="5" v-if="item1.NewPage>0" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"><b>{{item1.TestName}}</b></td> -->
            <td colspan="3" v-if="item1.NewPage>0" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}" style="text-decoration: underline;">
              <b>{{item1.TestName}}</b> <span v-if="item1.PropackName"> &nbsp; <i>[{{item1.PropackName}}]</i></span>
              <span v-if="item1.Specimen">&nbsp;&nbsp; ({{item1.Specimen}}) </span> <span v-if="item1.room_name">&nbsp;&nbsp;  {{item1.room_name}}</span>
            </td>
            <td colspan="3" v-else style="text-decoration: underline;">
              <b>{{item1.TestName}}</b> <span v-if="item1.PropackName"> &nbsp; <i>[{{item1.PropackName}}]</i></span>
              <span v-if="item1.Specimen">&nbsp;&nbsp; ({{item1.Specimen}}) </span> <span v-if="item1.room_name">&nbsp;&nbsp;  {{item1.room_name}}</span>
            </td>
          <!-- ----------------------- -->
        </tr>
        <!-- รายการเทส ที่อยู่ในชุดตรวจ (Detail) -->
        <template v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID">
          <tr class="text-start">
            <td style="width:450px;">
              <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName}} <span v-if="item1.PropackName && item1.CountItemTest<=1"> &nbsp; <i>[{{item1.PropackName}}]</i></span>
              <span v-if="item1.CountItemTest<=1 && item2.Specimen">&nbsp;&nbsp; ({{item2.Specimen}})</span>
              <span v-if="item1.CountItemTest<=1 && item2.room_name">&nbsp;&nbsp; {{item2.room_name}}</span>
            </td>
            <td style="width:110px;"> ........................ </td>
            <td style="width:120px;" > {{item2.Unit}}</td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="3"> <br> หมายเหตุ : {{A5reportHd.Remark}}</td>
      </tr>
    </tbody>
  </table>
</div>

<!-- BAR Code Label -->
<div id="divToPrint_LabelWithTestCodes" hidden>
  <span>
    <b> {{curRecord.Test}} <span v-if="curRecord.Test.length>0 && curRecord.TestInPropack.length>0">/</span> {{curRecord.TestInPropack}}  </b>
  </span>
</div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import JsBarcode from 'jsbarcode/bin/JsBarcode'

import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'LabResult1ViewV2',
  data () {
    return {
      arrCancel: ['', 'C'],
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      arrPaid: ['', 'Paid'],

      curRecord: { Test: '', TestInPropack: '' },
      // ตัวแปรสำหรับพิมพ์แบบ A5 มีชื่อชุดตรวจ
      A5dataheader: null,
      A5reportHd: {
        BranchID: 0,
        ROID: 0,
        RONo: '',
        DocDate: null,
        DocTime: null,
        PatID: 0,
        PatCode: '',
        PrefixName: '',
        PatName: 'สมชาย แข็งแรงดี',
        PatLName: '',
        PrefixName2: '',
        PatName2: '',
        PatLName2: '',
        IDNo: '',
        Sex: 0,
        Tel1: '',
        Tel2: '',
        AgeYears: 0,
        AgeMonths: 0,
        AgeDays: 0,
        ReqClinicID: 0,
        ReqClinicName: '',
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        OfficerName1Sign: '',
        OfficerID2: 0,
        OfficerName2: '',
        OfficerName2Sign: '',
        ResultedDate: null,
        OfficerID3: 0,
        OfficerName3: '',
        OfficerName3Sign: '',
        ApprovedDate: null,
        Remark: '',
        Status: 0
      },
      A5GroupTest: [],
      A5reportDtl: []
    }
  },
  props: ['datalists'],
  mounted () {

  },
  components: {

  },
  computed: {
    // a computed getter
    _vitalSignText: function () {
      var vitalSignText = ''
      if (this.A5reportHd === null || typeof this.A5reportHd === 'undefined') return vitalSignText
      // ----------------------------------- //
      if (this.A5reportHd.BP_1 !== '0' && typeof this.A5reportHd.BP_1 !== 'undefined') {
        vitalSignText = vitalSignText + '   BP: ' + this.A5reportHd.BP_1 + '/' + this.A5reportHd.BP_2 + ' mmHg.'
      }
      if (this.A5reportHd.Pulse !== '0' && typeof this.A5reportHd.Pulse !== 'undefined') {
        vitalSignText = vitalSignText + '   Pulse: ' + this.A5reportHd.Pulse + ' bpm.'
      }
      if (this.A5reportHd.Weight !== '0' && typeof this.A5reportHd.Weight !== 'undefined') {
        vitalSignText = vitalSignText + '   Weight: ' + this.A5reportHd.Weight + ' kg.'
      }
      if (this.A5reportHd.Height !== '0' && typeof this.A5reportHd.Height !== 'undefined') {
        vitalSignText = vitalSignText + '   Height: ' + this.A5reportHd.Height + ' cm.'
      }
      if (this.A5reportHd.Weight !== '0' && typeof this.A5reportHd.Weight !== 'undefined' &&
          this.A5reportHd.Height !== '0' && typeof this.A5reportHd.Height !== 'undefined') {
        let BMI = 0
        BMI = parseFloat(this.A5reportHd.Weight) / ((parseFloat(this.A5reportHd.Height) / 100) *
                                                      (parseFloat(this.A5reportHd.Height) / 100))
        vitalSignText = vitalSignText + '   BMI: ' + BMI.toFixed(2)
      }

      if (this.A5reportHd.BodyTemp !== '0' && typeof this.A5reportHd.BodyTemp !== 'undefined') {
        vitalSignText = vitalSignText + '   BodyTemp: ' + this.A5reportHd.BodyTemp + ' C.'
      }
      if (this.A5reportHd.SpO2 !== '0' && typeof this.A5reportHd.SpO2 !== 'undefined') {
        vitalSignText = vitalSignText + '   SpO2: ' + this.A5reportHd.SpO2 + ' %'
      }
      return vitalSignText.trim()
    }
  },
  methods: {
    textToBase64Barcode (text, heightValue) {
      var canvas = document.createElement('canvas')
      // var canvas = document.getElementById('myCanvas')
      JsBarcode(canvas, text, { width: 4, height: heightValue })
      var canvasDataURL = canvas.toDataURL('image/png')
      // console.log(canvasDataURL)
      return canvasDataURL
    },
    // แปลงไฟล์รูปภาพเป็น Base64 Image
    getBase64Image (img) {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      var dataURL = canvas.toDataURL('image/png')
      return dataURL
    },
    // ----------- (I.) รูปแบบใบแสดงผลเป็นฟอร์มสั่งตรวจเปล่าๆ A5, A4 ---------- //
    createPdfFormToScreen (paperSize, paperOrientation, viewAll) {
      var subHeader = ''
      var pageMarginsTop = 110
      if (this._vitalSignText !== '') {
        pageMarginsTop = pageMarginsTop + 12
        subHeader = subHeader + 'Vital signs: ' + this._vitalSignText
        if (this.A5reportHd.Specimen !== '') {
          pageMarginsTop = pageMarginsTop + 12
          subHeader = subHeader + '\n Specimen : ' + this.A5reportHd.Specimen
        }
      } else if (this.A5reportHd.Specimen !== '') {
        pageMarginsTop = pageMarginsTop + 12
        subHeader = subHeader + 'Specimen : ' + this.A5reportHd.Specimen
      }
      // ------------------------------------ //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName

      var DOBPrn = ''
      DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      // ==================================== //
      // ข้อความลายน้ำถ้าเอกสารยกเลิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        strWatermark = 'ใบสั่งตรวจ LAB REQUEST'
      }
      // =================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      var pdfTable = {}
      if (viewAll === 'ALL') {
        pdfTable = document.getElementById('divToPrint_MasterDtl')
      } else {
        pdfTable = document.getElementById('divToPrint')
      }
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'A5',
        // pageOrientation: 'landscape',
        // pageMargins: [20, 120, 20, 100],
        pageSize: paperSize,
        pageOrientation: paperOrientation,
        pageMargins: [20, pageMarginsTop, 20, 100],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.3, bold: true, italics: false },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  bold: true,
                  fontSize: 14,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 + ' Fax: ' + self.globalCorpInfo.fax + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: subHeader,
                  alignment: 'right',
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#DCDCDC'
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          const d = new Date()
          const textDate = d.toISOString().substr(0, 19).replace('T', ' ')
          return {
            margin: [20, 0, 20, 5],
            table: {
              widths: [220, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 11
                  },
                  { text: 'Created by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    // text: '\n', // image: self.A5reportHd.OfficerName1Sign,
                    image: self.A5reportHd.OfficerName1Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    text: '\n', // image: self.A5reportHd.OfficerName2Sign,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.A5reportHd.OfficerName1 + '\n' + self.A5reportHd.DocDate + ' ' + self.A5reportHd.DocTime,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: '', // self.A5reportHd.OfficerName3 + '\n' + self.A5reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: textDate,
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 15,
          lineHeight: 0.7
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    getA5ReportDtlData (row, formA5Idx) {
      var self = this
      var sqlFile = ''
      if (formA5Idx === 'A5-2' || formA5Idx === 'A4-2') {
        // ดึง TestItemห ของชุดตรวจมาด้วย
        // sqlFile = 'getdata/reqdtl_testitems_where_id.php'
        sqlFile = 'getdata/reqdtl_blank_form_testitems_where_id.php'
      } else {
        // ดึงเฉพาะขื่อชุดตรวจ
        // sqlFile = 'getdata/reqdtl_where_id.php'
        sqlFile = 'getdata/reqdtl_blank_form_where_id.php'
      }
      MyApiClient.get(sqlFile + '?ID=' + row.ROID)
        .then((resp) => {
          // รายการ items ผลตรวจทั้งหมด
          console.log(resp.data.response)
          self.A5reportDtl = resp.data.response
          // ========================================= //
          // คัดมาเฉพาะชื่อ TestSuit สำหรับจัดกลุ่มพิมพ์ เรียงตามชุด
          // ========================================= //
          const result = []
          const map = new Map()
          for (const item of self.A5reportDtl) {
            if (!map.has(item.TestID)) {
              map.set(item.TestID, true) // set any value to Map
              result.push(item)
            }
          }
          self.A5GroupTest = result
          // Print/Create Pdf
          if (formA5Idx === 'A5-1') {
            // รูปแบบ A5 : มีแต่ชื่อชุดตรวจ
            this.$nextTick(() => self.createPdfFormToScreen('A5', 'landscape', ''))
          } else if (formA5Idx === 'A4-1') {
            // รูปแบบ A4 : มีแต่ชื่อชุดตรวจ
            this.$nextTick(() => self.createPdfFormToScreen('A4', 'portrait', ''))
          } else if (formA5Idx === 'A5-2') {
            // รูปแบบ A5 : Master-Detail มีชื่อชุดตรวจ + เทส
            this.$nextTick(() => self.createPdfFormToScreen('A5', 'landscape', 'ALL'))
          } else if (formA5Idx === 'A4-2') {
            // รูปแบบ A4 : Master-Detail มีชื่อชุดตรวจ + เทส
            this.$nextTick(() => self.createPdfFormToScreen('A4', 'portrait', 'ALL'))
          }
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // A5reportDtl filter เฉพาะเทสที่อยู่ในชุดตรวจที่ส่งค่ามา paraTestID
    filterA5ItemsOfGroup: function (items, paraTestID) {
      return items.filter(function (item) {
        return item.TestID === paraTestID
      })
    },
    getA5ReportData (row, formA5Idx) {
      var self = this
      MyApiClient.get('getdata/labrequest_hd_where_id.php?ROID=' + row.ROID)
        .then((resp) => {
          self.A5dataheader = resp.data.response
          self.A5reportHd.ROID = self.A5dataheader[0].ROID
          self.A5reportHd.RONo = self.A5dataheader[0].RONo
          self.A5reportHd.DocDate = self.A5dataheader[0].DocDate
          self.A5reportHd.DocTime = self.A5dataheader[0].DocTime
          self.A5reportHd.PatCode = self.A5dataheader[0].PatCode
          self.A5reportHd.PrefixName = self.A5dataheader[0].PrefixName
          self.A5reportHd.PatName = self.A5dataheader[0].PatName
          self.A5reportHd.PatLName = self.A5dataheader[0].PatLName
          self.A5reportHd.PrefixName2 = self.A5dataheader[0].PrefixName2
          self.A5reportHd.PatName2 = self.A5dataheader[0].PatName2
          self.A5reportHd.PatLName2 = self.A5dataheader[0].PatLName2
          self.A5reportHd.IDNo = self.A5dataheader[0].IDNo
          self.A5reportHd.Sex = self.A5dataheader[0].Sex
          self.A5reportHd.Tel1 = self.A5dataheader[0].Tel1
          self.A5reportHd.Tel2 = self.A5dataheader[0].Tel2
          self.A5reportHd.BirthDate = self.A5dataheader[0].BirthDate
          self.A5reportHd.AgeYears = self.A5dataheader[0].AgeYears
          self.A5reportHd.AgeMonths = self.A5dataheader[0].AgeMonths
          self.A5reportHd.AgeDays = self.A5dataheader[0].AgeDays
          self.A5reportHd.ReqClinicName = self.A5dataheader[0].ReqClinicName
          self.A5reportHd.OfficerName1 = self.A5dataheader[0].OfficerName1
          self.A5reportHd.OfficerName2 = self.A5dataheader[0].OfficerName2
          self.A5reportHd.OfficerName3 = self.A5dataheader[0].OfficerName3
          self.A5reportHd.PassportNo = self.A5dataheader[0].PassportNo
          self.A5reportHd.Country = self.A5dataheader[0].Country
          self.A5reportHd.BP_1 = self.A5dataheader[0].BP_1
          self.A5reportHd.BP_2 = self.A5dataheader[0].BP_2
          self.A5reportHd.Pulse = self.A5dataheader[0].Pulse
          self.A5reportHd.Weight = self.A5dataheader[0].Weight
          self.A5reportHd.Height = self.A5dataheader[0].Height
          self.A5reportHd.BodyTemp = self.A5dataheader[0].BodyTemp
          self.A5reportHd.SpO2 = self.A5dataheader[0].SpO2
          self.A5reportHd.Specimen = self.A5dataheader[0].Specimen
          // ชื่อไฟล์ลายเซ็นต์ *.PNG
          self.A5reportHd.OfficerName1Sign = self.A5dataheader[0].OfficerName1Sign
          self.A5reportHd.OfficerName2Sign = self.A5dataheader[0].OfficerName2Sign
          self.A5reportHd.OfficerName3Sign = self.A5dataheader[0].OfficerName3Sign
          self.A5reportHd.ResultedDate = self.A5dataheader[0].ResultedDate
          self.A5reportHd.ApprovedDate = self.A5dataheader[0].ApprovedDate
          self.A5reportHd.Status = self.A5dataheader[0].Status
          self.A5reportHd.Remark = self.A5dataheader[0].Remark
          if (self.A5reportHd.ReqClinicName == null) {
            self.A5reportHd.ReqClinicName = ''
          }
          if (self.A5reportHd.OfficerName3 == null) {
            self.A5reportHd.OfficerName3 = ''
          }
          self.A5reportHd.Cancel = self.A5dataheader[0].Cancel

          // ========================================= //
          // ดึง Detail ของใบสั่งตรวจ
          // ========================================= //
          self.getA5ReportDtlData(row, formA5Idx)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    printROBlank (row, formA5Idx) {
      // ดึงข้อมูลให้เสร็จก่อนแล้วค่อยสร้างรายงาน เรียกแบบ promise
      // A5GroupTest
      //    A5reportDtl
      this.getA5ReportData(row, formA5Idx)
    },

    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.RONo,
        text: 'คุณแน่ใจหรือไม่...ที่จะยกเลิกข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/cancel_ro.php',
            data: { id: item.ROID },
            error: function (xhr, status, error) {
              Swal.fire({ icon: 'error', text: 'ไม่สามารถยกเลิกข้อมูลได้ ' + error })
            }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกยกเลิกเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              self.$emit('onBackPageAfterSaveEvent')
            })
          })
        }
      })
    },
    textToBase64BarcodeLABEL (text, barH) {
      var canvas = document.createElement('canvas')
      // var canvas = document.getElementById('myCanvas')
      JsBarcode(canvas, text, { width: 3, height: barH, font: 'monospace', fontOptions: 'bold' })
      var canvasDataURL = canvas.toDataURL('image/png')
      // console.log(canvasDataURL)
      return canvasDataURL
    },
    printROBarCode (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      var self = this
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      // var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })

      var documentDefinition = {
        // pageSize: 'A5',
        pageSize: { width: 2.0 * 72, height: 1.0 * 72 },
        // pageOrientation: 'landscape',
        pageMargins: [5, 0, 0, 5],
        content: [
          {
            columns: [
              {
                text: 'DATE : ' + ' ' + this.curRecord.DocDate,
                fontSize: 10,
                bold: true
              },
              {
                text: 'อายุ : ' + ' ' + this.curRecord.AgeYears + ' ปี',
                fontSize: 10,
                bold: true,
                alignment: 'right',
                margin: [2, 0, 5, 0]
              }
            ]
          },
          {
            columns: [
              {
                text: this.curRecord.PrefixName + this.curRecord.PatName + ' ' + this.curRecord.PatLName,
                fontSize: 10,
                bold: true,
                margin: [5, 0, 0, 0]
              }
            ]
          },
          {
            text: this.curRecord.PrefixName2 + this.curRecord.PatName2 + ' ' + this.curRecord.PatLName2,
            fontSize: 10,
            bold: true,
            margin: [5, 0, 0, 0]
          },
          {
            image: self.textToBase64BarcodeLABEL(self.curRecord.RONo, 45),
            width: 120,
            alignment: 'left',
            margin: [2, 0, 0, 0]
          }
        ],
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      // pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      pdfMake.createPdf(documentDefinition).print()
    },
    printROBarCode_Fs (row, Fs) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      var self = this
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      // var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })

      var documentDefinition = {
        // pageSize: 'A5',
        pageSize: { width: 2.0 * 72, height: 1.0 * 72 },
        // pageOrientation: 'landscape',
        pageMargins: [5, 0, 0, 5],
        content: [
          {
            columns: [
              {
                text: 'DATE : ' + ' ' + this.curRecord.DocDate,
                fontSize: 10,
                bold: true,
                lineHeight: 0.6
              },
              {
                text: 'อายุ : ' + ' ' + this.curRecord.AgeYears + ' ปี',
                fontSize: 10,
                bold: true,
                alignment: 'right',
                margin: [2, 0, 5, 0],
                lineHeight: 0.6
              }
            ]
          },
          {
            columns: [
              {
                text: this.curRecord.PrefixName + this.curRecord.PatName + ' ' + this.curRecord.PatLName,
                fontSize: Fs,
                bold: true,
                margin: [5, 0, 0, 0],
                lineHeight: 0.8
              }
            ]
          },
          {
            text: this.curRecord.PrefixName2 + this.curRecord.PatName2 + ' ' + this.curRecord.PatLName2,
            fontSize: 10,
            bold: true,
            margin: [5, 0, 0, 0],
            lineHeight: 0.8
          },
          {
            image: self.textToBase64BarcodeLABEL(self.curRecord.RONo, 45),
            width: 120,
            alignment: 'left',
            margin: [2, 0, 0, 0]
          }
        ],
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      // pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      pdfMake.createPdf(documentDefinition).print()
    },
    printROBarCodeTestCode_Fs (row, Fs) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_LabelWithTestCodes')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })

      var documentDefinition = {
        // pageSize: 'A5',
        pageSize: { width: 2.0 * 72, height: 1.0 * 72 },
        // pageOrientation: 'landscape',
        pageMargins: [5, 28, 0, 30],
        header: [
          {
            columns: [
              {
                text: 'DATE : ' + ' ' + this.curRecord.DocDate,
                fontSize: 10,
                bold: true,
                lineHeight: 0.6
              },
              {
                text: 'อายุ : ' + ' ' + this.curRecord.AgeYears + ' ปี',
                fontSize: 10,
                bold: true,
                alignment: 'right',
                margin: [2, 0, 5, 0],
                lineHeight: 0.6
              }
            ]
          },
          {
            columns: [
              {
                text: this.curRecord.PrefixName + this.curRecord.PatName + ' ' + this.curRecord.PatLName,
                fontSize: Fs,
                bold: true,
                margin: [0, 0, 0, 0],
                lineHeight: 0.6
              }
            ]
          },
          {
            text: this.curRecord.PrefixName2 + this.curRecord.PatName2 + ' ' + this.curRecord.PatLName2,
            fontSize: 10,
            bold: true,
            margin: [0, 0, 0, 0],
            lineHeight: 0.6
          }
        ],
        footer: function (currentPage, pageCount) {
          const d = new Date()
          const textDate = d.toISOString().substr(0, 19).replace('T', ' ')
          return [
            {
              columns: [
                {
                  image: self.textToBase64BarcodeLABEL(self.curRecord.RONo, 30),
                  width: 120,
                  alignment: 'left',
                  margin: [2, 0, 0, 0],
                  lineHeight: 0
                },
                { }
              ]
            },
            {
              columns: [
                {
                  text: textDate,
                  border: [0, 0, 0, 0],
                  alignment: 'left',
                  fontSize: 8,
                  lineHeight: 0.5
                },
                {
                  text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                  border: [0, 0, 0, 0],
                  alignment: 'right',
                  fontSize: 8,
                  lineHeight: 0.5
                }
              ]
            }
          ]
        },
        content: html,
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 12,
          lineHeight: 0.6
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      // pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      pdfMake.createPdf(documentDefinition).print()
    },
    editRecord (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      this.$emit('onEditRecordEvent', this.curRecord)
    },
    tableChanged (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // console.log(this.curRecord)
    }
  }
}
</script>

<style>

</style>
